import ChatListSidebar from '@/chat-common/conversation_list/components/ChatListSidebar'
import NewChatMatterBoundButton from '@/chat-common/new_chat/components/NewChatMatterBoundButton'
import { Dialog, Transition } from '@headlessui/react'
import { XClear } from '@/assets/icons'
import { Fragment } from 'react'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { setMobileChatHistoryOpen } from '@/store/slices/ui-state.slice'
import { RootState } from '@/store/store'
export default function DashboardMobileChatHistory() {
  const dispatch = useAppDispatch()

  const isMobileChatHistoryOpen = useAppSelector((state: RootState) => state.uiState.isMobileChatHistoryOpen)

  return (
    <Transition.Root show={isMobileChatHistoryOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => dispatch(setMobileChatHistoryOpen(false))}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-brand-neutral-900/80" />
        </Transition.Child>

        <div className="fixed inset-0 flex">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            {/* Slide-out panel */}
            <Dialog.Panel className="relative mr-16 flex flex-col w-full max-w-xs h-full bg-brand-neutral-50">
              {/* Close button pinned to the edge */}
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                  <button type="button" className="-m-2.5 p-2.5" onClick={() => dispatch(setMobileChatHistoryOpen(false))}>
                    <span className="sr-only">Close sidebar</span>
                    <XClear className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>

              {/* Sticky section with new chat button */}
              <div className="flex-shrink-0 p-4">
                <NewChatMatterBoundButton onClick={() => dispatch(setMobileChatHistoryOpen(false))} />
              </div>

              {/* Scrollable chat list */}
              <div className="flex-1 overflow-y-auto px-2">
                <ChatListSidebar onClickCallback={() => dispatch(setMobileChatHistoryOpen(false))} />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
